import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AccessoryViewModel, BankPortalService, DeployedHistoryViewModel, SparesRequestViewModel } from '../../../web-api-client';
import { PosHistory } from '../../../core/models/posHistory/pos-history.model';
import { Utilities } from '../../../core/models/utilities';
import * as moment from 'moment';
import { Support } from '../../../core/models/support/support.model';
import { SupportEdit } from '../../../core/models/support/support-edit.model';
import * as XLSX from 'xlsx';
import { SupportRequest } from '../../../core/models/bankportal.model';
import { SpareRequestEdit } from '../../../core/models/spareRequest/spare-request-edit.model';
import { SpareRequest } from '../../../core/models/spareRequest/spare-request.model';
import { Inventory } from '../../../core/models/inventory.model';
import { ToastrService } from 'ngx-toastr';


type AOA = any[][];

@Component({
  selector: 'accessories-requests',
  templateUrl: './accessories-requests.component.html'
})
export class AccessoriesRequestComponent implements OnInit {
  public accessoriesForm!: UntypedFormGroup;
  rows: DeployedHistoryViewModel[] = [];
  aaccessoryItems: AccessoryViewModel[] = [];
  roworiginal: DeployedHistoryViewModel[] = [];
  rowsCache: DeployedHistoryViewModel[] = [];
  rowsSupport: Support[] = [];
  submitted: boolean = false;
  rowsSupportCache: Support[] = [];
  editRow = new PosHistory();
  supportEdit = new SupportEdit();
  columnDefs: any[] = [];
  public addAccessories: boolean = false;
  public editAccessories: boolean = false;
  isDisabled:boolean=false
  file: any;
  arrayBuffer: any;
  filelist!: any[];
  public uploadType: string = "";
  public gridApi;
  private gridColumnApi;
  IsShowGrid: boolean = false;
  public defaultColDef;
  public rowSelection;
  public editIndex!: number;
  public addedRow: Array<any> = new Array<any>();
  public isUpdate: boolean = false;
  public editted: boolean = false;
  private selectedLink: string = "no";
  isReqSave: boolean = false;
  bankBranches:any[] = [];
  keyword = 'branchName';
  showModelBox: boolean = false;
  quickSearchValue: any;

  constructor(private formBuilder: UntypedFormBuilder, 
    private _el: ElementRef, 
    private bankPortalService: BankPortalService, 
    private _toastr: ToastrService) {
    this.loadPosHistorysData();
  }

  fileName: string = 'Upload_Format.xlsx';
  data: AOA = [['MERCHANT NAME', 'MERCHANT ID', 'TERMINAL ID', 'TERMINAL TYPE', 'SERIAL KEY', 'CONNECTIVITY', 'CONTACT PERSON', 'CONTACT NO', 'ISSUE', 'REMARKS']];

  showExcelData: boolean = false;
  dataForExcel = new SupportRequest();
  dataFromExcel: SupportRequest[] = [];
  public supRequest = new SupportRequest();
  public supportRequest = new SupportRequest();
  public supportRequestList: Array<SupportRequest> = new Array<SupportRequest>();
  isUpdating: boolean = false;
  public spareRequest = new SpareRequest();
  public spareRequestEdit = new SparesRequestViewModel();
  rows2: SparesRequestViewModel[] = [];
  spareId: any = null;
  ngOnInit() {

    this.columnDefs = [
      {
        headerName: 'Deployed Date', field: 'deployDate', valueFormatter: (data) => moment(data.value).format('ll'), width: 128, suppressSizeToFit: true, filter: 'date',
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            //using moment js
            var dateAsString = moment(cellValue).format('DD/MM/YYYY');
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          }
        }
      },
      { headerName: 'Merchant', field: 'merchant', width: 250, suppressSizeToFit: true },
      { headerName: 'Address', field: 'address', width: 180, suppressSizeToFit: true },
      { headerName: 'District', field: 'district', width: 130, suppressSizeToFit: true },
      { headerName: 'Province', field: 'province', width: 150, suppressSizeToFit: true },
      { headerName: 'Terminal ID', field: 'idTerminal', width: 150, suppressSizeToFit: true, cellRenderer: this.termId },
      { headerName: 'Merchant ID', field: 'idMerchant', width: 150, suppressSizeToFit: true, cellRenderer: this.merchantId },
      { headerName: 'Model', field: 'item', width: 140, suppressSizeToFit: true },
      { headerName: 'Serial Number', field: 'serialKey', width: 250, suppressSizeToFit: true, cellRenderer: this.serial },
      { headerName: 'Application Date', field: 'applicationFormat', width: 180, suppressSizeToFit: true },
      { headerName: 'Connectivity', field: 'connectivity', width: 150, suppressSizeToFit: true },
      { headerName: 'Deployed Location', field: 'merchantLocation', width: 180, suppressSizeToFit: true },
      { headerName: 'Contact No', field: 'contactNo1', width: 150, suppressSizeToFit: true, cellRenderer: this.contactNo },
      { headerName: 'Contact Person', field: 'contactPerson', width: 150, suppressSizeToFit: true },

    ];
    this.columnDefs.push({
      headerName: "Actions",
      suppressMenu: true,
      field: 'requestName',
      suppressSorting: true,
      width: 250,

      cellRenderer: this.actions,

    });

    this.loadTerminalData();
    this.loadPosHistorysData();
    this.loadBankBranches();
    this.accessoriesForm = this.formBuilder.group({
      accessoryId: ["", Validators.required],
      requested_Quantity: ["", Validators.required],
      location: [null, Validators.required],

    });
  }

  public serial(params: any) {
    var temp = params.data.serialKey;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public merchantId(params: any) {
    var temp = params.data.idMerchant;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public termId(params: any) {
    var temp = params.data.idTerminal;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public contactNo(params: any) {
    var temp = params.data.contactNo1;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }

  get f() {
    return this.accessoriesForm.controls;
  }

  loadPosHistorysData() {
    this.bankPortalService.bankPortal_GetHistory().subscribe(results => this.onHistoryDataLoadSuccessful(results), error => this.onHistoryDataLoadFailed(error));
  }


  onHistoryDataLoadSuccessful(posHistorys: DeployedHistoryViewModel[]) {
    posHistorys.forEach((posHistory, index, posHistorys) => {
      (<any>posHistory).index = index + 1;
    });
    this.rowsCache = [...posHistorys];
    this.rows = posHistorys;
    this.roworiginal = this.rows;
    //console.log(this.rows);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
  }
  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.quickSearchValue);
    
  }
  onHistoryDataLoadFailed(error) {
    this._toastr.error("Unable to load data", "Error");
  }

  public actions(params) {
    return (`<button type= "button btn-primary btn-sm"  data-action-type="Add"  class="btn-req btn-sm">Add Request</button>`);
  }

  gridOptions = {
    rowSelection: 'multiple',
    enableSorting: 'true',
    enableColResize: 'true',
    enableRtl: 'true',
    pagination: 'true',
    paginationAutoPageSize: 'true',
    animateRows: 'true',
    rowClicked: 'true'
  }

  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      let data = e.data;

      let actionType = e.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "Add":
          return this.AddSelect(data);

      }
    }
  }
  private AddSelect(row: PosHistory) {
    this.AddAccessories(row);
  }
  AddAccessories(row: PosHistory) {
    // this.addAccessories = true;
    this.showModelBox = true;
    this.editRow = row;
    this.isUpdating = false;


  }

  onRequest() {
    this.submitted = true;
    this.isDisabled=true;
    if (this.accessoriesForm.invalid) {
      return
    }
    else {

      if (this.isUpdating == true) {
        this.bankPortalService.bankPortal_UpdateSpareRequestbyBank(this.spareRequestEdit).subscribe(user => this.updateSuccessHelper(), error => this.updateFailedHelper(error));

      }
      else {
        this.bankPortalService.bankPortal_PostSpareRequestByBank(this.accessoriesForm.value).subscribe(user => this.saveSuccessHelper(), error => this.saveFailedHelper(error));
      }
      this.submitted = false;
      this.hide();

    }

  }
  private saveSuccessHelper(spareRequest?: SpareRequestEdit) {
    Object.assign(this.spareRequest, this.spareRequestEdit);
    this.spareRequestEdit = new SparesRequestViewModel();
    this.spareRequest = new SpareRequest();
    this._toastr.success("Accessories Request has been submitted","");
    this.isDisabled=false;
    this.loadSpareRequest();
  }
  public item(params) {
    return (params.data.primaryItem + " - " + params.data.secondaryItem + " - " + params.data.tertiaryItem + " - " + params.data.detailItem);
  }
  private saveFailedHelper(error: any) {
    this._toastr.error("Accessories Request cannot be added","Save Error");
    this.isDisabled=false;
  }

  private updateSuccessHelper(spareRequest?: SpareRequestEdit) {
    Object.assign(this.spareRequest, this.spareRequestEdit);
    this.spareRequestEdit = new SparesRequestViewModel();
    this.spareRequest = new SpareRequest();
    this._toastr.success("Accessories Request has been updated Sucessfully","");
    this.isDisabled=false;
    this.loadSpareRequest();
  }
  private updateFailedHelper(error: any) {
    this._toastr.error("Accessories Request cannot be updated","Save Error");
    this.isDisabled=false;

  }

  private loadSpareRequest() {

    this.bankPortalService.bankPortal_GetSparesRequests().subscribe(results => this.onDataLoadSuccessfulRequest(results), error => this.onDataLoadFailedSpare(error));
  }
  onDataLoadSuccessfulRequest(inventorys: SparesRequestViewModel[]) {
    inventorys.forEach((inventory, index, inventorys) => {
      (<any>inventory).index = index + 1;
    });
    if (this.spareId === null) {
      this.rows2 = inventorys;

    }
    if (this.spareId !== null) {
      this.rows2 = inventorys;
      this.rows2 = this.rows2.filter(x => x.id == this.spareId);
    }


  }
  onDataLoadFailedSpare(error: any) {
    // this.alertService.stopLoadingMessage();
    //this.loadingIndicator = false;

  }

  hide() {
    // this.addAccessories = false;
    // this.editAccessories = false;
    this.showModelBox = false;
    this.submitted = false;
  }

  onSearchChanged(value: string) {
    this.rows = this.rowsCache.filter(r => Utilities.searchArray(value, false, r.merchant, r.idMerchant, r.idTerminal, r.item, r.address, r.contactPerson, r.serialKey));
  }

  addfile(event) {
    this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      this.filelist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      console.table(this.filelist);

      var arraylist:any = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      //console.log(arraylist);
      for (let item of arraylist) {
        this.dataForExcel = new SupportRequest();
        this.dataForExcel.MerchantName = item['MERCHANT NAME'];
        this.dataForExcel.MerchantId = item['MERCHANT ID'];
        this.dataForExcel.TerminalId = item['TERMINAL ID'];
        this.dataForExcel.TerminalType = item['TERMINAL TYPE'];
        this.dataForExcel.SerialKey = item['SERIAL KEY'];
        this.dataForExcel.Connectivity = item['CONNECTIVITY'];
        this.dataForExcel.ContactPerson = item['CONTACT PERSON'];
        this.dataForExcel.ContactNo = item['CONTACT NO'];
        this.dataForExcel.Issue = item['ISSUE'];
        this.dataForExcel.Remarks = item['REMARKS'];
        this.dataFromExcel = [];
        this.dataFromExcel.push(JSON.parse(JSON.stringify(this.dataForExcel)));

        for (var z = 0; z < this.dataFromExcel.length; z++) {
          var supportRequest = new SupportRequest();
          supportRequest.MerchantName = this.dataFromExcel[z].MerchantName;
          supportRequest.MerchantId = this.dataFromExcel[z].MerchantId;
          supportRequest.TerminalId = this.dataFromExcel[z].TerminalId;
          supportRequest.TerminalType = this.dataFromExcel[z].TerminalType;
          supportRequest.SerialKey = this.dataFromExcel[z].SerialKey;
          supportRequest.Connectivity = this.dataFromExcel[z].Connectivity;
          supportRequest.ContactPerson = this.dataFromExcel[z].ContactPerson;
          supportRequest.ContactNo = this.dataFromExcel[z].ContactNo;
          supportRequest.Issue = this.dataFromExcel[z].Issue;
          supportRequest.Remarks = this.dataFromExcel[z].Remarks;

          this.addedRow.push(JSON.parse(JSON.stringify(supportRequest)));

        }

        this.supRequest.BankPortalDepReqVM = this.addedRow;
        this.supportRequestList.push(JSON.parse(JSON.stringify(this.supportRequest)));
        this.supportRequest = new SupportRequest();
        this.uploadType = 'Single Entry';
        this.goToBottom();



      }
    }

  }

  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  deleteRow(index) {
    if (this.editIndex == index) {
      this._toastr.error(`It can't be delete as it is open in Edit Mode `,"Sorry");
    }
    else {
      this.addedRow.splice(index, 1);
      this._toastr.show(`Request Deleted !!`,"");

    }

  }

  edit(index) {
    this.isUpdate = true;
    this.editted = true;
    this.editIndex = index;
  }

  goToBottom() {
    const el: HTMLDivElement = this._el.nativeElement;
    el.scrollTop = Math.max(0, el.scrollHeight - el.offsetHeight);

  }
  onScroll(event: any) {

    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {

    }
  }

  loadBankBranches() {
    this.bankPortalService.bankPortal_GetBankBranch().subscribe(res => this.successLoadBankBranch(res), error => this.unSuccess(error));

  }
  successLoadBankBranch(res: any[]) {
    this.bankBranches = res;
  }

  unSuccess(error: any) {
    // this.notify.showError("Error", "Error !!");
  }
  bankBranchselectEvent(item: { branchName: any; }) {
    this.accessoriesForm.patchValue({ location: item.branchName });
    //this.deploymentRequest.BranchName = item.branchName;
  }

  onChangeSearch(search: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e: any) {
  }


  loadTerminalData() {
    //this.inventory.hasSerialNo = true;
    this.bankPortalService.bankPortal_GetSparesDataInfo().subscribe(results => this.onDataLoadSuccessfulInventory(results), error => this.onDataLoadFailedInventory(error));
  }
  onDataLoadSuccessfulInventory(accessory: AccessoryViewModel[]) {
    this.aaccessoryItems = accessory;
  }
  onDataLoadFailedInventory(error: any) {
    // this.alertService.stopLoadingMessage();
    //this.loadingIndicator = false;

  }

}


